import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Lock, Clock, BookOpen, TrendingUp } from 'lucide-react';
import { PricingGrid } from './pricing/PricingGrid';
import { FreeTrialOption } from './pricing/FreeTrialOption';

export const PlanGate = ({ onSelectPlan }) => {
  const navigate = useNavigate();
  const { api } = useAuth();

  useEffect(() => {
    document.documentElement.classList.remove('dark');
    document.documentElement.classList.add('light');
  }, []);

  const handleSelectPlan = (plan) => {
    if (onSelectPlan) {
      onSelectPlan(plan.id);
    } else {
      navigate(`/billing?plan=${plan.id}`);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-white border-b border-gray-200 py-4 px-6 flex items-center justify-between">
        <div className="med900-logo text-xl">
          <span className="med900-logo-med">Med</span>
          <span className="med900-logo-900">900</span>
          <span className="med900-logo-dot">.</span>
        </div>
        <span className="text-gray-400 text-sm font-plex">UCAT Practice</span>
      </header>

      <main className="flex-1 flex items-center justify-center p-6">
        <div className="max-w-6xl w-full">
          <div className="text-center mb-10">
            <div className="inline-flex items-center justify-center w-14 h-14 bg-primary/10 rounded-full mb-5">
              <Lock className="h-7 w-7 text-primary" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
              Choose Your Study Plan
            </h1>
            <p className="text-base text-gray-500 max-w-xl mx-auto">
              Every plan includes full access to practice questions, mock exams, analytics, and study guides.
              Pick the access period that suits you.
            </p>
          </div>

          <PricingGrid api={api} onSelectPlan={handleSelectPlan} />

          <div className="grid md:grid-cols-3 gap-4 mt-10 mb-10">
            {[
              { icon: BookOpen, color: 'text-primary', bg: 'bg-primary/10', title: '1000+ Questions', sub: 'Across all sections' },
              { icon: Clock, color: 'text-purple-600', bg: 'bg-purple-100', title: 'Timed Mocks', sub: 'Realistic exam conditions' },
              { icon: TrendingUp, color: 'text-green-600', bg: 'bg-green-100', title: 'Analytics', sub: 'Track your progress' },
            ].map(({ icon: Icon, color, bg, title, sub }) => (
              <div key={title} className="bg-white border border-gray-200 rounded-xl p-4 text-center">
                <div className={`inline-flex items-center justify-center w-10 h-10 ${bg} rounded-full mb-3`}>
                  <Icon className={`h-5 w-5 ${color}`} />
                </div>
                <h4 className="font-semibold text-gray-900 text-sm mb-1">{title}</h4>
                <p className="text-xs text-gray-400">{sub}</p>
              </div>
            ))}
          </div>

          <div className="text-center space-y-2">
            <p className="text-gray-400 text-xs">
              7-day money-back guarantee · Secure payment via Stripe · Cancel anytime
            </p>
            <FreeTrialOption />
          </div>
        </div>
      </main>
    </div>
  );
};
